import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiBaseUrl } from "../../config";
import { ResponseModel } from "../../models/apiModels";
import { RootState } from "../store";

export interface ConfigModel {
  googlesitekey: string | undefined;
  googleprojectid: string | undefined;
  googleapikey: string | undefined;
  olarksiteid: string | undefined;
  olarkgroup: string | undefined;
  hotjarid: number | undefined;
  hotjarsnippetversion: number | undefined;
  privacyLink: string | undefined;
}

export interface ConfigState {
  data: ConfigModel;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: ConfigState = {
  data: {
    googleapikey: undefined,
    googleprojectid: undefined,
    olarksiteid: undefined,
    olarkgroup: undefined,
    googlesitekey: undefined,
    hotjarid: undefined,
    hotjarsnippetversion: undefined,
    privacyLink: "https://www.telstra.com.au/privacy",
  },
  status: "idle",
  error: null,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<ConfigModel>) {
      state.data = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getConfig.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(
        getConfig.fulfilled,
        (state, action: PayloadAction<ConfigModel | undefined>) => {
          state.status = "succeeded";
          state.data =
            { ...state.data, ...action.payload } || initialState.data;
        }
      )
      .addCase(getConfig.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      });
  },
});

export const { setConfig } = configSlice.actions;
export default configSlice.reducer;

export const selectConfig = (state: RootState) => state.config.data;

export const getConfig = createAsyncThunk("config/getConfig", async () => {
  const response = await fetch(`${ApiBaseUrl}/config`);
  const responseJson: ResponseModel<ConfigModel> = await response.json();

  return responseJson.result;
});
